export default {"src":"/_next/static/media/location.fa85c34f.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};